import {
    all, put, PutEffect, select, SelectEffect, takeLatest,
} from "redux-saga/effects";
import axios, {AxiosResponse} from "axios";
import {Nullable, safeSaga} from "@data-force/app";
import {GET_TASK_LIST} from "../actions/availableActions";
import {GetTaskListAction, UpdateTaskListAction} from "../../interfaces/store/actions/task";
import {updateTaskList} from "../actions/task";
import {getBaseUrl} from "./main";
import {Task} from "../../interfaces/store/actions/payload/task";
import StoreState from "../../interfaces/store/storeState";
import {JobEntity} from "../../interfaces/store/actions/payload/job";
import {SetLoadingAction} from "../../interfaces/store/actions/mask";
import {setLoading} from "../actions/mask";
import {GetTaskListResponse} from "../../interfaces/store/sagas/task";

type GetTaskListIteratorType =
    SelectEffect
    | Promise<AxiosResponse<GetTaskListResponse>>
    | PutEffect<UpdateTaskListAction | SetLoadingAction>;

function* getTaskListHandler({payload}: GetTaskListAction): IterableIterator<GetTaskListIteratorType> {
    const baseUrl: Nullable<string> = yield getBaseUrl();
    yield put(setLoading(true));
    const selectedJob: Nullable<JobEntity> = yield select(
        (state: StoreState): Nullable<JobEntity> => state.job.selectedJob,
    );
    if (selectedJob) {
        const {projectId, jobId}: JobEntity = selectedJob;
        const axiosResponse: Nullable<AxiosResponse<GetTaskListResponse>> = yield axios.get(
            `${baseUrl}/project/${projectId}/job/${jobId}/task`,
            {
                params: {
                    ...payload?.cursor || null,
                    phaseName: payload?.phaseName,
                    phaseStatus: payload?.phaseStatus,
                    name: payload?.name,
                },
            },
        );

        if (axiosResponse) {
            const {data: {items, cursor}}: AxiosResponse<GetTaskListResponse> = axiosResponse;
            if (payload?.cursor) {
                if (items) {
                    const tasks: Nullable<Task[]> = yield select((state: StoreState): Task[] => state.task.list);
                    yield put(updateTaskList({
                        list: [...tasks!, ...items as Task[]],
                        cursor: cursor || payload?.cursor || null,
                    }));
                }
            } else {
                yield put(updateTaskList({
                    list: items as Task[] || [],
                    cursor: cursor || null,
                }));
            }
        }
    }
    yield put(setLoading(false));
}

export function* taskSagaActionWatcher() {
    yield all([
        takeLatest(GET_TASK_LIST, safeSaga(getTaskListHandler)),
    ]);
}
